// src/components/ServiceGrid.tsx
import { Container, Grid, Typography, Box } from "@mui/material";
import { motion, Variants } from "framer-motion";
import { ServiceCard } from "./ServiceCard";
import { netcomServices } from "../data/services";

// 1. Define animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Time between each card appearing
    },
  },
};

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export const ServiceGrid = () => {
  return (
    <Box sx={{ bgcolor: "background.default", py: 10 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" fontWeight={800} textAlign="center" mb={8} color="primary">
          Our Specialist Services
        </Typography>

        {/* 2. Wrap the Grid in a motion.div for the container logic */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }} // Triggers when 20% of the section is visible
        >
          <Grid container spacing={4} alignItems="stretch">
            {netcomServices.map((service) => (
              <Grid
                size={{ xs: 12, sm: 6, md: 4 }}
                key={service.id}
                sx={{ display: "flex" }} // Critical for equal height
              >
                {/* 3. Each card gets its own motion wrapper */}
                <motion.div variants={cardVariants} style={{ display: "flex", width: "100%", height: "100%" }}>
                  <ServiceCard service={service} />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};
